import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=0c14e396&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&lang=ts&"
export * from "./ProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=0c14e396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c14e396",
  null
  
)

export default component.exports